import React from "react";
import "./_RingSelector.scss";
import Ring from "../Ring/Ring";
import RingSelectButton from "../RingSelectButton/RingSelectButton";

export const RingSelector = () => {
  return (
    <div className="ring-selector">
      <div className="mobile-ring-selector">
        <Ring />
        <div className="selectors">
          <RingSelectButton mainRing />
          <RingSelectButton mainRing={false} />
        </div>
      </div>
      <div className="desktop-ring-selector">
        <RingSelectButton mainRing />
        <Ring />
        <RingSelectButton mainRing={false} />
      </div>
    </div>
  );
};
